import {createContext} from "react";

export const ProductFormContext = createContext({
    productLock: {},
    selectedLocale: null,
    setSelectedLocale: () => {}
})
